var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColorGredientSizeLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 55,
    viewBox: "0 0 220 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1587_9899",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 219,
    height: 55
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.755859 54.6582V0.637817H20.1713V38.4522H48.2016V54.6582H0.755859Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.755859 54.6582V0.637817H20.1713V38.4522H48.2016V54.6582H0.755859Z",
    fill: "url(#paint0_linear_1587_9899)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.369 54.6582V0.637817H122.613L138.171 27.455H139.972V0.637817H158.937V54.6582H137.143L121.07 27.8409H119.335V54.6582H100.369Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.369 54.6582V0.637817H122.613L138.171 27.455H139.972V0.637817H158.937V54.6582H137.143L121.07 27.8409H119.335V54.6582H100.369Z",
    fill: "url(#paint1_linear_1587_9899)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.0521 26.6271L98.3639 0.637817H77.9841L73.2518 9.13007L79.9083 21.075L83.0521 26.6271ZM76.3127 38.0663V54.6582H56.8329V37.8733L34.8457 0.637817H55.2899L65.8977 19.6736L76.3127 38.0663Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.0521 26.6271L98.3639 0.637817H77.9841L73.2518 9.13007L79.9083 21.075L83.0521 26.6271ZM76.3127 38.0663V54.6582H56.8329V37.8733L34.8457 0.637817H55.2899L65.8977 19.6736L76.3127 38.0663Z",
    fill: "url(#paint2_linear_1587_9899)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.242 27.7123L157.727 54.6582H178.878L187.558 40.5101H189.422L198.101 54.6582H213.583L187.558 14.0143L179.071 0.637817H158.242L176.242 26.7478V27.7123Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.242 27.7123L157.727 54.6582H178.878L187.558 40.5101H189.422L198.101 54.6582H213.583L187.558 14.0143L179.071 0.637817H158.242L176.242 26.7478V27.7123Z",
    fill: "url(#paint3_linear_1587_9899)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M197.843 0.637817H218.737L207.893 16.4794L206.066 19.1485L196.053 3.48297L197.843 0.637817Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M197.843 0.637817H218.737L207.893 16.4794L206.066 19.1485L196.053 3.48297L197.843 0.637817Z",
    fill: "url(#paint4_linear_1587_9899)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1587_9899)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1,
    width: 221,
    height: 55,
    fill: "url(#paint5_linear_1587_9899)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1587_9899",
    x1: 0.755859,
    y1: 0.637817,
    x2: 35.6966,
    y2: 61.8019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F5FF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#E224F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766949,
    stopColor: "#FAAA0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A327D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1587_9899",
    x1: 100.369,
    y1: 0.637817,
    x2: 131.29,
    y2: 67.4528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F5FF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#E224F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766949,
    stopColor: "#FAAA0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A327D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1587_9899",
    x1: 34.8457,
    y1: 0.637817,
    x2: 64.1303,
    y2: 69.2662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F5FF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#E224F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766949,
    stopColor: "#FAAA0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A327D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1587_9899",
    x1: 157.727,
    y1: 0.637817,
    x2: 189.589,
    y2: 66.3012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F5FF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#E224F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766949,
    stopColor: "#FAAA0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A327D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1587_9899",
    x1: 196.053,
    y1: 0.637817,
    x2: 205.8,
    y2: 24.4453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F5FF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#E224F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766949,
    stopColor: "#FAAA0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A327D0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1587_9899",
    x1: -1,
    y1: 0,
    x2: 9.15507,
    y2: 81.3275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F5FF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#E224F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.766949,
    stopColor: "#FAAA0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A327D0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorGredientSizeLarge);
export default __webpack_public_path__ + "static/media/Color=Gredient, Size=Large.e8592b55be0114da55388cd23b7355ad.svg";
export { ForwardRef as ReactComponent };